<template>
  <div>
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="asgnRplcLIToFC_tooltip_NAME"  :name="asgnRplcLIToFC_tooltip_NAME" :description="asgnRplcLIToFC_tooltip_DESCRIPTION" :editable="editable"></tool-tip>
    <div v-if="!replacementItemEnabled">
      Assign Replacement Line Item to Fund Citation is not required for this transaction... Please Continue...
    </div>
    <div v-else>
      <div class="row">
        <div class="col-sm-12">
          <el-table
            :data="replacementItems"
            :summary-method="summary"
            show-summary
            :default-sort="{ prop: 'itemNumber', order: 'ascending' }"
          >
            <el-table-column
              :min-width="100"
              prop="itemNumber"
              label="Item No"
            />
            <el-table-column
              :min-width="140"
              align="left"
              label="Fund Citation"
            >
              <editable-cell
                :disabled="isReadOnly || isPartnerAccount"
                :show-input="editMode"
                slot-scope="{ row }"
                editable-component="el-select"
                close-event="change"
                v-model="row.fundCitationId"
                v-on:input="markChanged(row.lineItemId)"
              >
                <span slot="content">
                  {{ row.fundCitationName }}
                </span>
                <template slot="edit-component-slot">
                  <el-option
                    v-for="fundCitation in fundCitations"
                    class="select-primary"
                    :label="fundCitation.abbreviation"
                    :value="fundCitation.fundCitationId"
                    :key="fundCitation.fundCitationId"
                  >
                  </el-option>
                </template>
              </editable-cell>
            </el-table-column>
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :formatter="column.formatter"
              :prop="column.prop"
              :label="column.label"
            >
            </el-table-column>
          </el-table>
          <div style="margin-top: 20px; float: right" v-if="!isReadOnly && !isPartnerAccount">
            <base-button
              :disabled="isReadOnly || isPartnerAccount"
              v-show="editMode"
              type="danger"
              class="alert_footer_button btn_extra_small btn_info mr-4"
              @click.native="cancelEditMode"
            >
              Cancel
            </base-button>
            <base-button
              :disabled="isReadOnly || isPartnerAccount"
              type="primary"
              class="alert_footer_button btn_extra_small btn_info"
              @click.native="handleEdit()"
            >
              {{ editMode ? "Save" : "Edit" }}
            </base-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Table, TableColumn, Option, Select, Input } from "element-ui";
import { BaseSwitch, BaseButton } from "@/components";
import EditableCell from "@/components/App/order/invoice/assignlineitemfundcitation/LineItemEditable.vue";
import Util from "../../../../../util/util";
import toolTip  from "../../../Tooltip";

export default {
  name: "replacement-fund-citation",
  props: ["isReadOnly"],
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    BaseSwitch,
    BaseButton,
    EditableCell,
    toolTip
  },
  data() {
    return {
      editMode: false,
      changedItems: [],
      tableColumns: [
        {
          prop: "stockClassName",
          label: "Class of Supply",
          minWidth: 150,
        },
        {
          prop: "stockSubClassName",
          label: "Sub Class",
          minWidth: 150,
        },
        {
          prop: "stockDescription",
          label: "stock No & Description",
          minWidth: 200,
        },
        {
          prop: "unitMeasure",
          label: "Unit Of Measure",
          minWidth: 150,
        },
        {
          prop: "requestedQuantity",
          label: "Request Qty",
          minWidth: 150,
          formatter: (value) => {
            return Util.numberWithCommas(value.requestedQuantity);
          },
        },
        {
          prop: "receivedQuantity",
          label: "Received Qty",
          minWidth: 150,
          formatter: (value) => {
            return Util.numberWithCommas(value.receivedQuantity);
          },
        },
        {
          prop: "unitPrice",
          label: "Unit Price",
          minWidth: 125,
          formatter: (value) => {
            return Util.inMoneyFormatWithoutDollarSign(value.unitPrice);
          },
        },
        {
          prop: "partnerItemTotal",
          label: "Partner Total",
          minWidth: 170,
          formatter: (value) => {
            return Util.inMoneyFormatWithoutDollarSign(value.partnerItemTotal);
          },
        },
        {
          prop: "usItemTotal",
          label: "US Total($)",
          minWidth: 125,
          formatter: (value) => {
            return Util.inMoneyFormatWithoutDollarSign(value.usItemTotal);
          },
        },
      ],
      asgnRplcLIToFC_tooltip_NAME : '',
      asgnRplcLIToFC_tooltip_DESCRIPTION : '',
    };
  },
  async mounted() {
   await this.getAllTooltips()
   this.loadToolTips()
 },
  computed: {
    ...mapGetters({
      fundCitations: "fundCitation/fundCitations",
      replacementItems: "replacementItemInvoice/replacementItems",
      replacementItemsErrors: "replacementItemInvoice/replacementItemErrors",
      replacementItemEnabled: "replacementItemInvoice/replacementItemEnabled",
      isPartnerAccount: "authentication/isPartnerAccount",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable"
    }),
  },
  methods: {
    ...mapActions({
      getFundCitations: "fundCitation/getFundCitations",
      getFundCitationStatus: "fundCitation/getFundCitationStatus",
      getReplacementItems: "replacementItemInvoice/getReplacementItems",
      saveReplacementItems: "replacementItemInvoice/saveReplacementItems",
      getReplacementItemEnabled: "replacementItemInvoice/getReplacementItemEnabled",
      getReplacementItemInvoiceStatus: "replacementItemInvoice/getReplacementItemInvoiceStatus",
      getReconciliationStatus: "reconciliationStatus/getReconciliationStatus",
      getReplacementItemStatus: "replacementItem/getReplacementItemStatus",
      getAllTooltips: "tooltip/getToolTips"
    }),
    loadToolTips(){
    const asgnRplcLIToFCVal = this.toolTips.find(e => e.name === "AssignReplacementModule")
    if(asgnRplcLIToFCVal && asgnRplcLIToFCVal.status){
      this.asgnRplcLIToFC_tooltip_DESCRIPTION = asgnRplcLIToFCVal.description ? asgnRplcLIToFCVal.description: null
      this.asgnRplcLIToFC_tooltip_NAME = asgnRplcLIToFCVal.name ? asgnRplcLIToFCVal.name: null
    }
    return 
      
    },
    updateToolTip(updatedData){
      this.loadToolTips()
      },
     showReplacementItemsErrors () {
      if(!Util.isNullOrEmpty(this.replacementItemsErrors) && this.replacementItemsErrors.length > 0 ) {
            this.replacementItemsErrors.forEach(error => this.$toast.error(error))
        }
    },
    loaded() {
      let ctx = this;
      ctx.getFundCitations(this.$route.params.id);
      ctx.getReplacementItemInvoiceStatus(ctx.$route.params.id);
      ctx.getReplacementItemEnabled(ctx.$route.params.id).then(() => {
        if (ctx.replacementItemEnabled) {
          ctx.getReplacementItems(ctx.$route.params.id);
        }
      });
    },
    cancelEditMode() {
      this.editMode = false;
      this.getReplacementItems(this.$route.params.id);
    },
    async handleEdit() {
      if (this.editMode) {
        await this.saveItemQuantities();
      } else {
        this.editMode = true;
      }
    },
    markChanged(id) {
      if(this.changedItems.includes(id)) return;

      this.changedItems.push(id);
    },
    async saveItemQuantities() {
      let updateStatus = false;
      // Loop through each of the line items
      // Fetch LineItem for each
      let bases = this.replacementItems.filter(item => this.changedItems.includes(item.lineItemId));
      let items = bases.map(itm => {
        return {
          lineItemId: itm.lineItemId,
          orderId: itm.orderId,
          fundCitationId: itm.fundCitationId,
        }
      }); 

      try {
        const res = await this.saveReplacementItems(items);
        updateStatus = true;
        this.changedItems = [];
        
        await this.getReplacementItems(this.$route.params.id);
        
        this.getFundCitationStatus(this.$route.params.id);
        
        this.getReplacementItemInvoiceStatus(this.$route.params.id).then(() => this.showReplacementItemsErrors());

        this.$toast.success(res.data);
      } catch (error) {
        this.$toast.error("ERROR: Cannot save the 'Replacement Receipt Items' at this time.");
      }

      this.editMode = false;
    },

    generateTotal(values) {
      this.getReconciliationStatus(this.$route.params.id);
      if (!values.every((value) => isNaN(value))) {
        this.getReconciliationStatus(this.$route.params.id);
        return values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            this.getReconciliationStatus(this.$route.params.id);
            return prev + curr;
          } else {
            this.getReconciliationStatus(this.$route.params.id);
            return prev;
          }
        }, 0);
      } else {
        this.getReconciliationStatus(this.$route.params.id);
        return null;
      }
    },
    summary(param) {
      const { columns, data } = param;
      const sums = [];
      const totalColumns = ["usItemTotal"];
      const quantityColumns = [
        "requestedQuantity",
        "receivedQuantity",
        "unitPrice",
        "partnerItemTotal",
      ];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Totals";
          return;
        }

        if (quantityColumns.includes(column.property)) {
          const values = data.map((item) => Number(item[column.property]));
          const total = this.generateTotal(values);
          sums[index] = total
            ? Util.inMoneyFormatWithoutDollarSign(total)
            : "0.00";
          if (column.property == "requestedQuantity" || column.property == "receivedQuantity") {
            sums[index] = total ? Util.numberWithCommas(total) : "0.00";
          }
        } else if (totalColumns.includes(column.property)) {
          const values = data.map((item) => Number(item[column.property]));
          const total = this.generateTotal(values);
          sums[index] = total
            ? `$ ${Util.inMoneyFormatWithoutDollarSign(total)}`
            : "$ 0.00";
        } else {
          sums[index] = "N/A";
        }
      });
      return sums;
    },
  },
};
</script>
